import React from "react";
import { CSSTransition } from "react-transition-group";
import animationStyles from "./animation.module.scss";
import styles from "./styles.module.scss";
import searchIconSVG from "../../../SVGcomponents/search-icon.svg";

type Props = {
  isOpened: boolean;
  closeModal: (event: any) => void;
  children: React.ReactNode;
  sx?: React.CSSProperties;
  className?: string;
  hideCloseButton?: boolean;
};

const overlayAnimation = {
  enter: animationStyles.overlayEnter,
  enterActive: animationStyles.overlayEnterActive,
  exit: animationStyles.overlayExit,
  exitActive: animationStyles.overlayExitActive,
};

const contentAnimation = {
  enter: animationStyles.contentEnter,
  enterActive: animationStyles.contentEnterActive,
  exit: animationStyles.contentExit,
  exitActive: animationStyles.contentExitActive,
};

export const ModalLayout = ({
  isOpened,
  closeModal,
  children,
  sx,
  className,
  hideCloseButton = false,
}: Props) => {
  const overlayRef = React.useRef();
  const contentRef = React.useRef();
  const [animationIn, setAnimationIn] = React.useState(false);

  React.useEffect(() => {
    setAnimationIn(isOpened);
  }, [isOpened]);

  React.useEffect(() => {
    const handleEscKeyPress = (event: KeyboardEvent) => {
      if (event.key === "Escape" && isOpened) {
        closeModal(event);
      }
    };

    document.addEventListener("keydown", handleEscKeyPress);

    return () => {
      document.removeEventListener("keydown", handleEscKeyPress);
    };
  }, [isOpened, closeModal]);

  return (
    <div className={styles["container"]}>
      <CSSTransition
        in={animationIn}
        nodeRef={overlayRef}
        mountOnEnter
        unmountOnExit
        classNames={overlayAnimation}
        timeout={300}
      >
        <div
          ref={overlayRef}
          className={styles["modal-overlay"]}
          onClick={closeModal}
        />
      </CSSTransition>
      <CSSTransition
        in={animationIn}
        nodeRef={contentRef}
        timeout={300}
        mountOnEnter
        unmountOnExit
        classNames={contentAnimation}
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
          ref={contentRef}
          className={`${styles["modal-content"]} ${className || ""}`}
          style={{ ...sx }}
        >
          {!hideCloseButton && (
            <span onClick={closeModal} className={styles["close-modal-btn"]}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M4.16992 15.8337L15.8366 4.16699M4.16992 4.16699L15.8366 15.8337"
                  stroke="var(--text-secondary)"
                />
              </svg>
            </span>
          )}
          {children}
        </div>
      </CSSTransition>
    </div>
  );
};
